import { render, staticRenderFns } from "./WarningTemplate.vue?vue&type=template&id=63ba8aba&scoped=true&"
import script from "./WarningTemplate.vue?vue&type=script&lang=js&"
export * from "./WarningTemplate.vue?vue&type=script&lang=js&"
import style0 from "./WarningTemplate.vue?vue&type=style&index=0&id=63ba8aba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ba8aba",
  null
  
)

export default component.exports